import React, { useCallback, useEffect } from 'react';
import './osano.css';


declare global {
  interface Window {
    Osano?: any;
  }
}

const openOsano = () => {
  if (window.Osano && window.Osano.cm) {
    window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
  }
};

export const OndeckOsano: React.FC<{ label?: string; className?: string }> = ({
  label = 'Do Not Sell or Share My Personal Information',
  className = '', }) => {

  // Inject Osano script if not already present
  useEffect(() => {
    if (!document.querySelector(`script[src="${import.meta.env.VITE_OSANO_SCRIPT_URL}"]`)) {
      const script = document.createElement('script');
      script.src = import.meta.env.VITE_OSANO_SCRIPT_URL;
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  const handleClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    openOsano();
  }, []);

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openOsano();
    }
  }, []);

  return (
    <li className="nav-item">
      <a
        className={`${className}`}
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        aria-label={label}
        style={{ cursor: 'pointer' }}
      >
        {label}
      </a>
    </li>
  );
};